import {
	ChangeDetectionStrategy,
	Component,
	EventEmitter,
	input,
	Input,
	OnInit,
	Output,
	signal,
	ViewChild,
} from '@angular/core';

import { MatInputModule } from '@angular/material/input';
import { FormControl, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { NgxMaskDirective, NgxMaskPipe } from 'ngx-mask';
import { CmmsPages } from '@app/pages/cmms/state/cmms.reducer';
import { NgxTolgeeModule } from '@tolgee/ngx';

@Component({
	selector: 'au-cmms-cost',
	imports: [
		MatInputModule,
		ReactiveFormsModule,
		MatFormFieldModule,
		NgxMaskDirective,
		NgxMaskPipe,
		NgxTolgeeModule,
	],
	templateUrl: './au-cmms-cost.component.html',
	styleUrls: ['./au-cmms-cost.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AuCmmsCostComponent implements OnInit {
	@Input() set value(cost: string) {
		this.formControl.patchValue(cost);
	}
	@Input() labelName = 'cost_of_work';

	@Input() data: {
		activePage: CmmsPages;
		columnName: string;
		preselectedValue: string;
	};
	maxNumOfDigits = input<number>(8);

	@Output() controlReady = new EventEmitter<FormControl>();
	@Output() valueChanged = new EventEmitter<string>();
	@Output() inputBlur = new EventEmitter<string>();
	@ViewChild('inputHTMLField', { static: false }) inputHTMLField;

	inputOnFocus = signal(false);
	formControl = new FormControl('', [
		Validators.pattern(`^\\d{1,${this.maxNumOfDigits()}}(\\.\\d{1,2})?$`),
	]);
	timerID: any;

	ngOnInit(): void {
		this.controlReady.emit(this.formControl);
		this.applyPreselectedFilterValue();
	}

	keyDownHandler() {
		if (this.timerID) {
			clearTimeout(this.timerID);
		}

		this.timerID = setTimeout(() => {
			this.valueChanged.emit(this.getValidValue());
		}, 300);
	}

	enterKeyDownHandler(event: KeyboardEvent) {
		event.preventDefault();
		this.formControl.markAsTouched();

		if (this.formControl.valid) {
			this.inputHTMLField.nativeElement.blur();
		}
	}

	onBlurHandler() {
		this.inputOnFocus.set(false);
		this.inputBlur.emit(this.getValidValue());
	}

	private getValidValue() {
		const value = this.formControl.value;
		return value || (value?.length && +value === 0) ? Number(value).toFixed(2) : null;
	}

	private applyPreselectedFilterValue() {
		if (this.data?.preselectedValue) {
			this.formControl.patchValue(this.data.preselectedValue);
		}
	}
}
